<template>
  <div :class="['CloseButton', {'CloseButton--dark': dark}]"
    @mouseenter="onMouseOver"
    @click="$emit('click', $event.target.value)"
  >
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.17157 12.2427L3.75736 10.8284L6.58579 8.00002L3.75736 5.1716L5.17157 3.75738L8 6.58581L10.8284 3.75738L12.2426 5.1716L9.41421 8.00002L12.2426 10.8284L10.8284 12.2427L8 9.41424L5.17157 12.2427Z"/>
    </svg>
    <div class="CloseButton-borders"></div>
  </div>
</template>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    onMouseOver () {}
  }
}
</script>

<style lang="stylus" scoped>
  .CloseButton
    width 24px
    height 24px
    border-radius 4px
    color white
    text-align center
    cursor pointer
    display flex
    align-items center
    justify-content center
    &-borders
      border-radius 4px
      position absolute
      width calc(100%)
      height calc(100%)
      border 1px solid white
      top 0
      left 0
      transform-origin  50% 50%
      z-index 1
      transition all 200ms linear
    svg
      position relative
      width 16px
      fill white
      z-index 5
    &:hover
      .CloseButton-borders
        background white
        transform scale(1.2)
      svg
        fill black

    &--dark
      .CloseButton-borders
        border 1px solid black
      svg
        fill black
      &:hover
        .CloseButton-borders
          background rgba(0, 0, 0, 1)
        svg
          fill white
</style>
